import { SchedulePlanningToolPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import PlanningToolSchedule from './PlanningToolSchedule'

const SchedulePlanningToolPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const {
    data: page,
    loading,
    error,
  } = useQuery(SchedulePlanningToolPageDocument, {
    variables: {
      companyId: companyId,
    },
  })

  const isNewPlanningToolEnabled = !!page?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_projects_new_planning_tool'
  )?.enabled

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      showHeader={false}
      loading={loading}
      error={error}
      authorized={isNewPlanningToolEnabled}
    >
      <PlanningToolSchedule />
    </ResponsivePage.Body>
  )
}

export default SchedulePlanningToolPage
